import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import LocaleLink from '@components/LocaleLink';
import { withRouter } from 'next/router';
import { TertiaryRouteContainer, LinkButton } from '../TertiaryOptions.styles';

function TertiaryRoute(props) {
  const { label, route, router, routeName } = props;
  const { query } = router;
  const { defaultMessage } = label;
  const isSelected = routeName === route;
  return (
    <TertiaryRouteContainer>
      <LocaleLink route={route} params={query} passHref>
        <LinkButton isSelected={isSelected}>{defaultMessage?.[0]?.value}</LinkButton>
      </LocaleLink>
    </TertiaryRouteContainer>
  );
}

TertiaryRoute.propTypes = {
  label: PropTypes.shape({ defaultMessage: PropTypes.string }).isRequired,
  route: PropTypes.string.isRequired,
  router: PropTypes.shape({ query: PropTypes.shape({}) }).isRequired,
  routeName: PropTypes.string.isRequired
};
const ComposedTertiaryRoute = compose(withRouter)(TertiaryRoute);
export default ComposedTertiaryRoute;
